import { useState } from "react";
import { usePortal } from "@/context/PortalContext";
import portalApi from "@/lib/portalApi";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { LockKey } from "@phosphor-icons/react";

export default function ForceChangePinKaryawan() {
  const { karyawan, markPinChanged } = usePortal();
  const [oldPin, setOldPin] = useState("123456");
  const [newPin, setNewPin] = useState("");
  const [newPin2, setNewPin2] = useState("");
  const [saving, setSaving] = useState(false);

  if (!karyawan || !karyawan.pin_default) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (newPin.length !== 6 || !/^\d{6}$/.test(newPin)) {
      toast.error("PIN baru harus 6 digit angka");
      return;
    }
    if (newPin !== newPin2) {
      toast.error("Konfirmasi PIN tidak cocok");
      return;
    }
    if (newPin === "123456") {
      toast.error("PIN baru tidak boleh sama dengan PIN default");
      return;
    }
    setSaving(true);
    try {
      await portalApi.post("/karyawan-auth/change-pin", { old_pin: oldPin, new_pin: newPin });
      toast.success("PIN berhasil diubah. Selamat datang!");
      markPinChanged();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" data-testid="force-change-pin-karyawan">
      <form onSubmit={submit} className="bg-white rounded-xl p-6 w-full max-w-sm space-y-4 shadow-2xl">
        <div className="flex items-center gap-2 text-amber-600">
          <LockKey size={26} weight="duotone"/>
          <h2 className="font-heading text-lg font-bold">Wajib Ganti PIN</h2>
        </div>
        <p className="text-sm text-slate-600">
          Anda masih pakai PIN default. Silakan buat PIN baru 6 digit untuk keamanan akun Anda.
        </p>
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1">PIN Lama (default)</label>
          <input
            data-testid="pin-old"
            type="password" inputMode="numeric" maxLength={6}
            value={oldPin} onChange={e=>setOldPin(e.target.value.replace(/\D/g,""))}
            className="input font-mono-tab text-center tracking-widest w-full"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1">PIN Baru (6 digit)</label>
          <input
            data-testid="pin-new"
            type="password" inputMode="numeric" maxLength={6} required
            value={newPin} onChange={e=>setNewPin(e.target.value.replace(/\D/g,""))}
            className="input font-mono-tab text-center tracking-widest w-full"
            placeholder="••••••"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-600 mb-1">Konfirmasi PIN Baru</label>
          <input
            data-testid="pin-new-confirm"
            type="password" inputMode="numeric" maxLength={6} required
            value={newPin2} onChange={e=>setNewPin2(e.target.value.replace(/\D/g,""))}
            className="input font-mono-tab text-center tracking-widest w-full"
            placeholder="••••••"
          />
        </div>
        <button
          data-testid="pin-submit"
          type="submit" disabled={saving}
          className="w-full py-3 bg-[#00558F] hover:bg-[#003E6B] disabled:opacity-50 text-white rounded-lg font-bold"
        >
          {saving ? "Menyimpan..." : "Simpan PIN Baru"}
        </button>
      </form>
    </div>
  );
}
